import * as React from 'react';

import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';
import { TableReact } from '../../Table';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface InnerCorrelationProps {
  innerCorrelationTable: any;
}

interface InnerCorrelationMainState {
  innerCorrelation: any;
  innerCorrelationData: any;
  innerCorrelationColumns: any;
}

class InnerCorrelationMain extends React.Component<InnerCorrelationProps, InnerCorrelationMainState> {
  constructor(props: InnerCorrelationProps) {
    super(props);
    this.state = {
      innerCorrelation: props.innerCorrelationTable,
      innerCorrelationColumns: [],
      innerCorrelationData: [],
    };
  }

  componentDidMount() {
    const { innerCorrelation } = this.state;
    if (innerCorrelation) {
      const columns = this.getColumns(innerCorrelation);
      const data = this.getData(innerCorrelation);

      this.setState({
        innerCorrelationColumns: columns,
        innerCorrelationData: data,
      });
    }
  }

  componentDidUpdate(prevProps: InnerCorrelationProps) {
    if (prevProps !== this.props) {
      const { innerCorrelationTable } = this.props;
      if (innerCorrelationTable) {
        const columns = this.getColumns(innerCorrelationTable);
        const data = this.getData(innerCorrelationTable);

        this.setState({
          innerCorrelation: innerCorrelationTable,
          innerCorrelationColumns: columns,
          innerCorrelationData: data,
        });
      }
    }
  }

  getColumns = (innerCorrelation: any) => [
    ...[
      {
        Header: '',
        Cell: (props: any) => (
          <div>
            <div className="alphas-comparison__correlation-color" style={{ backgroundColor: props.value.color }} />
            <div className="alphas-comparison__correlation-name">{props.value.name}</div>
          </div>
        ),
        accessor: 'label',
        fixed: 'left',
      },
    ],
    ...innerCorrelation.map((correlationData: any) => ({
      Header: (props: any) => (
        <div>
          <div className="alphas-comparison__correlation-color" style={{ backgroundColor: correlationData.color }} />
          <div className="alphas-comparison__correlation-header">{correlationData.text}</div>
          <div className="alphas-comparison__correlation-arrows">
            <div className={`alphas-comparison__correlation-arrows--up${correlationData.ascSort ? '--active' : ''}`} />
            <div className={`alphas-comparison__correlation-arrows--down${correlationData.descSort ? '--active' : ''}`} />
          </div>
        </div>
      ),
      accessor: correlationData.id,
      Cell: (props: any) => <div className="alphas-comparison">{props.value}</div>,
      minWidth: 175,
      ascSort: false,
      descSort: false,
    })),
  ];

  getData = (innerCorrelation: any) => {
    const dataIds = innerCorrelation.map((innerCorrelationElement: any) => innerCorrelationElement.id);

    return innerCorrelation.map((innerCorrelationElement: any) => {
      const result: any = {};
      dataIds.map((id: string, index: number) => {
        result[id] = innerCorrelationElement.data[index];
      });
      result.label = {
        name: innerCorrelationElement.text,
        color: innerCorrelationElement.color,
      };

      return result;
    });
  };

  onSortChange = (newSorted: any, column: any, shiftKey: any) => {
    const innerCorrelationSorted = this.state.innerCorrelation.map((correlationData: any) => {
      if (correlationData.id === newSorted[0].id) {
        correlationData.ascSort = !newSorted[0].desc;
        correlationData.descSort = newSorted[0].desc;
      } else {
        correlationData.ascSort = false;
        correlationData.descSort = false;
      }

      return correlationData;
    });
    this.setState({ innerCorrelation: innerCorrelationSorted });
  };

  render() {
    const { innerCorrelation, innerCorrelationColumns, innerCorrelationData } = this.state;

    return (
      <div className="alphas-comparison__correlation">
        <div className={addModifiers('alphas-comparison__title', ['correlation'])}>
          <FormattedMessageHelper
            tagName="span"
            id="alphasComparisonMain.innerCorrelation"
            defaultMessage={localeData.en['alphasComparisonMain.innerCorrelation']}
          />
        </div>
        {innerCorrelation ? (
          <TableReact
            data={innerCorrelationData}
            columns={innerCorrelationColumns}
            showPagination={false}
            minRows={1}
            onSortedChange={this.onSortChange}
            className="alphas-comparison__correlation-table"
          />
        ) : (
          <div className="alphas-comparison__correlation__no-results">
            <FormattedMessageHelper tagName="span" id={'no.data.available'} defaultMessage={localeData.en['no.data.available']} />
          </div>
        )}
      </div>
    );
  }
}

export default InnerCorrelationMain;
